import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from '../base/local-modal';
import React, { FC, useState } from 'react';
import logoutIcon from 'assets/icons/logout-icon.svg';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';
import { DepartmentType } from 'models/department.model';

interface DeleteDepartemntModalProps {
  show: boolean;
  onClose: () => void;
  activeDepartment: DepartmentType;
  handleDeleteDepartment: (id: string) => void;
}

interface DeleteDepartemntModalFooterProps {
  onCancel: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const DeleteDepartemntModalFooter: FC<DeleteDepartemntModalFooterProps> = ({
  onCancel,
  onConfirm,
  loading
}) => (
  <div className='flex gap-2'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      onClick={onConfirm}
      loading={loading}>
      Confirm
    </Button>
  </div>
);

const DeleteDepartemntModal: FC<DeleteDepartemntModalProps> = ({
  show,
  onClose,
  activeDepartment,
  handleDeleteDepartment
}) => {
  const [loading, setLoading] = useState(false);

  const confirmDelete = async () => {
    setLoading(true);
    try {
      const res = await apiService.delete(`department/${activeDepartment.id}`);
      if (res) {
        toast(<ToastMessage type='success' message='Department deleted successfully' />);
        handleDeleteDepartment(activeDepartment.id);
        onClose();
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalModal
      isOpen={show}
      description={``}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <DeleteDepartemntModalFooter
          onCancel={() => onClose()}
          onConfirm={() => confirmDelete()}
          loading={loading}
        />
      }>
      <div className='flex flex-col justify-center items-center'>
        <img src={logoutIcon} className='mx-auto mb-5' />
        <p className='text-[#2E3031] text-center'>
          Are you sure you want to remove {activeDepartment.name} Department?
        </p>
      </div>
    </LocalModal>
  );
};

export default DeleteDepartemntModal;
